import Component from '../Component';

import { createElement } from '../../support/dom';
import { addClass, removeClass } from '../../support/classes';

class Node extends Component
{
    constructor(text, link, nodes, props, parent)
    {
        super(null, props);

        this.parent = parent;

        this.text = text;
        this.link = link;
        this.nodes = nodes;
        this.children = [];

        this.x = 0;
        this.y = 0;

        this.left = 0;
        this.top = 0;

        this.width = 0;
        this.height = 0;

        this.initialize();
    }

    getDefaultProps()
    {
        return {};
    }

    initialize()
    {
        // <div class="node-back">
        if (this.parent)
        {
            this.back = createElement('div', null, {
                class: 'node-back',
            });
        }

        // <div class="node-text">
        this.textContainer = createElement('div', this.text, {
            class: 'node-text',
        });

        // <div class="node-inner">
        this.inner = createElement('div', [
            this.back,
            this.textContainer,
        ], {
            class: 'node-inner',
        });

        // <div class="node-next">
        if (this.nodes && this.nodes.length)
        {
            this.addNodes(this.nodes);

            this.next = createElement('div', null, {
                class: 'node-next',
            });

            this.inner.appendChild(this.next);
        }

        // <div class="node">
        this.element = createElement('a', this.inner, {
            class: 'node',
            href: this.link,
        });
    }

    appendTo(element)
    {
        element.appendChild(this.element);

        this.children.forEach((child) => {
            child.appendTo(element);
        });
    }

    forEach(callback)
    {
        return this.children.forEach(callback);
    }

    hasChildren()
    {
        return !!this.children.length;
    }

    getLink()
    {
        return this.element.getAttribute('href');
    }

    find(node)
    {
        if (this === node)
        {
            return this;
        }

        return this.children.find((child) => {
            return child.find(node);
        });
    }

    /**
     * Recursively checks children for the matching element.
     */
    findByElement(element)
    {
        // This Node matches the element passed.
        if (this.element === element)
        {
            return this;
        }

        // Recursively check children for a match.
        for (let i = 0, len = this.children.length; i < len; i++)
        {
            let found = this.children[i].findByElement(element);

            if (found)
            {
                return found;
            }
        }

        return false;
        // return this.children.find((child) => {
        //     return child.findByElement(element);
        // });
    }

    addNodes(nodes)
    {
        nodes.forEach((node) => {
            this.addNode(node);
        });
    }

    addNode({ text, link, nodes, props })
    {
        const node = new Node(text, link, nodes, props, this);

        this.children.push(node);
    }

    isActive()
    {
        return this.active;
    }

    setActive(active)
    {
        this.active = active;

        if (active)
        {
            addClass(this.element, `node-active`);
        }
        else
        {
            removeClass(this.element, `node-active`);
        }

        this.setVisible(active);
    }

    /**
     * @param {bool} visible The visibility of the node.
     * @param {bool} ignoreChildren If false, set the visiblity of the children nodes as well.
     */
    setVisible(visible, ignoreChildren)
    {
        if (visible)
        {
            addClass(this.element, `node-visible`);
        }
        else
        {
            removeClass(this.element, `node-visible`);
        }

        if (ignoreChildren)
        {
            return;
        }

        for (let i = 0, len = this.children.length; i < len; i++)
        {
            this.children[i].setVisible(visible, true);
        }
    }

    setPosition(x, y)
    {
        const { offsetWidth, offsetHeight } = this.element.parentNode;
        const width = this.element.offsetWidth;
        const height = this.element.offsetHeight;

        let dl = x - (width / 2),
            dt = y - (height / 2);
        
        // Keep the node inside the bounds.
        if (dl < 0)
        {
            dl = 0;
        }

        if (dt < 0)
        {
            dt = 0;
        }

        if (dl + width > offsetWidth)
        {
            dl = offsetWidth - width;
        }

        if (dt + height > offsetHeight)
        {
            dt = offsetHeight - height;
        }

        this.x    = dl + (width / 2);
        this.y    = dt + (height / 2);
        this.left = dl;
        this.top  = dt;

        this.element.style.left = `${this.left}px`;
        this.element.style.top  = `${this.top}px`;

        this.positionChildren();
    }

    positionChildren()
    {
        const childCount = this.children.length;
        const stepAngle = Math.PI * 2 / childCount;
        let angle;

        this.children.forEach((child, i) => {
            if (child.hasPosition)
            {
                return;
            }

            angle = i * stepAngle;

            child.setPosition(
                this.x + (2 * this.element.offsetWidth * Math.cos(angle)),
                this.y + (2 * this.element.offsetHeight * Math.sin(angle))
            );
        });
    }

    show()
    {
        this.element.style.display = 'block';
        this.visible = true;
    }

    hide()
    {
        this.element.style.display = 'none';
        this.visible = false;
    }
}

export default Node;